import React from "react";
import gynocol from "../../assets/images/Gynecology-img.png";
import heart from "../../assets/images/heart-img.png";
import lung from "../../assets/images/lung-img.png";
import ophtham from "../../assets/images/Ophthalmology-img.png";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
const HomePageService = () => {
  return (
    <div className="flex justify-center items-center flex-col py-28">
      <div className=" text-[#243FFA] text-[16px] text-center font-normal font-outfit">
        WHAT WE PROVIDE
      </div>
      <h2 className="xl:text-[52px] text-[32px] font-outfit text-center font-semibold text-[#0F2349]">
        Our Medical Services
      </h2>
      <p className="text-[#757887] text-lg font-normal text-center font-outfit">
        Molestiae non recusandae earum rerum hic tenetur asa piente delectus.
      </p>
      <div className="xl:w-3/4 w-[95%] mt-8  flex justify-center gap-6 items-center flex-col lg:flex-row">
        <div className=" lg:w-1/2 w-full flex justify-end flex-col md:flex-row gap-6  ">
          <div
            className="xl:w-64 pt-11 pl-8 pr-9 pb-6 rounded-xl flex flex-col border-[1.5px] border-transparent hover:border-blue-700 gap-1"
            style={{ boxShadow: "2px 2px 52px 6px rgb(36 63 250 / 4%)" }}
          >
            <figure className="h-[70px]">
              <img src={heart} alt="" />
            </figure>
            <div className="text-[#0F2349] text-[22px] font-semibold font-outfit">
              Cardiologist
            </div>
            <p className="text-[#757887] leading-[1.5rem] text-[16px] font-outfit my-2 font-normal">
              Duis aute irure dolor in reprehenderit in voluta zesse cillum…
            </p>
            <p className="text-[16px] font-bold font-outfit">
              <a href="/" className="text-[#243ffa]">
                Learn More <NavigateNextIcon />
              </a>
            </p>
          </div>
          <div
            className="xl:w-64 pt-11 pl-8 pr-9 pb-6 rounded-xl flex flex-col border-[1.5px] border-transparent hover:border-blue-700 gap-1"
            style={{ boxShadow: "2px 2px 52px 6px rgb(36 63 250 / 4%)" }}
          >
            <figure className="h-[70px]">
              <img src={lung} alt="lung" />
            </figure>
            <div className="text-[#0F2349] text-[22px] font-semibold font-outfit">
              Pulmonary
            </div>
            <p className="text-[#757887] leading-[1.5rem] text-[16px] font-outfit my-2 font-normal">
              Duis aute irure dolor in reprehenderit in voluta zesse cillum…
            </p>
            <p className="text-[16px] font-bold font-outfit">
              <a href="/" className="text-[#243ffa]">
                Learn More <NavigateNextIcon />
              </a>
            </p>
          </div>
        </div>
        <div className="lg:w-1/2 w-full flex justify-start  flex-col md:flex-row gap-6  ">
          <div
            className="xl:w-64 pt-11 pl-8 pr-9 pb-6 rounded-xl flex flex-col border-[1.5px] border-transparent hover:border-blue-700 gap-1"
            style={{ boxShadow: "2px 2px 52px 6px rgb(36 63 250 / 4%)" }}
          >
            <figure className="h-[70px]">
              <img src={gynocol} alt="gynocol" />
            </figure>
            <div className="text-[#0F2349] text-[22px] font-semibold font-outfit">
              Gynecology
            </div>
            <p className="text-[#757887] leading-[1.5rem] text-[16px] font-outfit my-2 font-normal">
              Duis aute irure dolor in reprehenderit in voluta zesse cillum…
            </p>
            <p className="text-[16px] font-bold font-outfit">
              <a href="/" className="text-[#243ffa]">
                Learn More <NavigateNextIcon />
              </a>
            </p>
          </div>
          <div
            className="xl:w-64 pt-11 pl-8 pr-9 pb-6 rounded-xl flex flex-col border-[1.5px] border-transparent hover:border-blue-700 gap-1"
            style={{ boxShadow: "2px 2px 52px 6px rgb(36 63 250 / 4%)" }}
          >
            <figure className="h-[70px]">
              <img src={ophtham} alt="" />
            </figure>
            <div className="text-[#0F2349] text-[22px] font-semibold font-outfit">
              Ophthalmology
            </div>
            <p className="text-[#757887] leading-[1.5rem] text-[16px] font-outfit my-2 font-normal">
              Duis aute irure dolor in reprehenderit in voluta zesse cillum…
            </p>
            <p className="text-[16px] font-bold font-outfit">
              <a href="/" className="text-[#243ffa]">
                Learn More <NavigateNextIcon />
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePageService;
